export const EVENTS = "EVENTS";
export const BOOK_EVENT = "BOOK_EVENT";
export const IKEA_FAMILY_ONLY = "IKEA_FAMILY_ONLY";
export const DIGITAL = "DIGITAL";
export const PHYSICAL = "PHYSICAL";
export const CANCELLED = "REMOVED";
export const ACTIVE = "ACTIVE";
